import React, { createRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import toast from 'react-hot-toast';
import { Input, Select, Spinner } from '../../../components';
import { NoFileImage, BravealoImage, Vector4 } from '../../../assets/img';
import { PurchasesService, GeneralService, SubscriptionsService } from '../../../services';
import { RestartIcon, CloseIcon } from '../../../assets/icons';
import { classNames, Constants, Globals, Alert } from '../../../utils';

const ORIGINS = {
	ANDROID: 1,
	IOS: 2,
	WEB: 3
}

class CompleteVehicleData extends React.Component {

	goBack = createRef();
	confirmModalRef = createRef();

	state = {
		form: {
			brand: '',
			model: '',
			year: '',
			vehicle_type: '',
			serial: '',
			plate: '',
			engine_serial: '',
			mileage: '100',
			color: '',
			weight: ''
		},
		purchase_req_doc: null,
		document_photo: null,
		isLoading: false,
		attempts_available: 0,
		initial_loading: true,
		product_id: null
	}

	componentDidMount() {
		this.goBack.current = document.getElementById('header-goback');
    	this.goBack.current.classList.remove('hidden');

		this.faceIdentityToken();
	}

	componentWillUnmount() {
	    this.goBack.current.classList.add('hidden');
	}

	change = (value,target,callback = () => {},uppercase = false) => {
		this.setState({
			form: { ...this.state.form, [target]: uppercase ? value.toUpperCase() : value },
		},() => callback());
	}

	faceIdentityToken = async () => {
		await this.setState({
			isLoading: true
		});

		try {
			if (!this.props.history?.location?.state?.item?.id) {
				this.props.history.replace('/');
				return;
			}
			const res = await PurchasesService.faceIdentityToken({
				payment_id: this.props.history?.location?.state?.item?.id
			});
			if (res.purchase_req_doc) {
				await this.setState({
					purchase_req_doc: res.purchase_req_doc,
					product_id: res.product_id
				});
			}
			if (res.vehicle_data) {
				await this.setState({
					attempts_available: res.attempts_available,
					form: {
						...this.state.form,
						brand: res.vehicle_data?.brand || '',
						model: res.vehicle_data?.model || '',
						year: res.vehicle_data?.year?.toString() || '',
						vehicle_type: res.vehicle_data?.type || res.vehicle_data?.vehicle_type || '',
						serial: res.vehicle_data?.serial || '',
						plate: res.vehicle_data?.plate || '',
						engine_serial: res.vehicle_data?.serial || '',
						color: res.vehicle_data?.color || '',
						weight: res.vehicle_data?.weight || ''
					}
				},() => {
					this.saveFile();
				});
			}
			else {
				this.getData();
			}
		} catch (error) {
			console.log(error);
		} finally {
			this.setState({
				isLoading: false
			});
		}
	}

	getData = async () => {
		await this.setState({
			isLoading: true,
			initial_loading: false
		});

		try {
			// Se comenta la función ya que genera un error debido a que Netuno tiene bloqueada la página
			// const response = await fetch('https://api.ipify.org?format=json');
    	// const data = await response.json();

			const res = await PurchasesService.verifyVehicleCard({
				hasFile: true,
				payment_id: this.props.history?.location?.state?.item?.id,
				origin_id: ORIGINS.WEB,
				document_photo: this.state.document_photo,
				ip: null
			});
			this.setState({
				document_photo: null
			});
			if (res.purchase_req_doc) {
				this.setState({
					purchase_req_doc: res.purchase_req_doc
				});
			}
			if (res.vehicle_data) {
				this.setState({
					attempts_available: res.attempts_available,
					form: {
						...this.state.form,
						brand: res.vehicle_data?.brand || '',
						model: res.vehicle_data?.model || '',
						year: res.vehicle_data?.year?.toString() || '',
						vehicle_type: res.vehicle_data?.type || '',
						serial: res.vehicle_data?.serial || '',
						plate: res.vehicle_data?.plate || '',
						engine_serial: res.vehicle_data?.serial || '',
						color: res.vehicle_data?.color || '',
						weight: res.vehicle_data?.weight || ''
					}
				});
			}
		} catch (error) {
			console.log(error);
		} finally {
			this.setState({
				isLoading: false
			});
		}
	}

	// submit = async () => {
	// 	await this.setState({
	// 		isLoading: true
	// 	});

	// 	try {
	// 		const res = await PurchasesService.updateVehicleData({
	// 			...this.state.form,
	// 			purchase_req_doc_id: this.state.purchase_req_doc?.id,
	// 			payment_id: this.props.history?.location?.state?.item?.id
	// 		});
	// 		if (res?.message) toast.error(res.message);
	// 		this.confirmModalRef.current?.showModal();
	// 	}
	// 	catch(e) {
	// 		console.log(e);
	// 	} finally {
	// 		this.setState({
	// 			isLoading: false
	// 		});
	// 	}
	// }
	saveFile = async () => {
		const { brand, model, year, vehicle_type, serial, plate, color, weight, category, engine_serial, mileage } = this.state.form;
		const { user } = this.props;

		const data = {
			client: user.id,
			route: 'emitirAuto',
			codprod: 'RCVD',
			codplan: '005',
			revplan: '001',
			tipoid: 'V',
			numid: user.dni, // CÉDULA
			dvid: 0,
			nomter: user.name || '', // NOMBRES
			apeter: user.last_name || '', // APELLIDOS
			fecnac: user.birthdate ? moment(user.birthdate).format('DD/MM/YYYY') : '',
			sexo: user.gender_id === Constants.GENDER.MALE ? 'M' : 'F', // SEXO: M/F
			email: user.email, // EMAIL
			telofi: user.phone || '', // Tlf contacto
			codpais: '001',
			codestado: '', // Consultar en Backend
			codciudad: '', // Consultar en Backend
			codmunicipio: '', // Consultar en Backend
			codparroquia: '',
			codsect: '',
			direccion: user.address || '',
			marca: brand, // Consultar en Backend 
			modelo: model, // Consultar en Backend
			version: '',
			claseVehiculos: '000002',
			anmoveh: year, // Año del vehículo
			placa: plate, // Placa
			serialCarroceria: serial, // Serial carrocería
			serialMotor: engine_serial, // Serial motor
			clase: '',
			color: color || 'BLANCO', // Color
			kilometraje: mileage, // Kilometraje
			indnuevo: 'N', // Indicador si es nuevo el vehículo (N)
			fechaAdq: "10/06/2022", // Fecha de adquisición (dd/mm/yyyy)
			tipocar: '',
			tipodes: '',
			zipecode: '2101',
			peso: weight || '450', //Peso del vehiculo 
			coddestinado: "P", //Destino del Vehículo P (particular), C (carga)
			codcobro: 2, //2: WEBAPP
			//payment_id: item.payment_id, //AQUI NO SE HA PAGADO AÚN,
			user_data: {
				gender_id: user?.gender_id,
				dni: user?.dni?.substring(1),
				birthdate: user.birthdate ? moment(user?.birthdate).format('YYYY-MM-DD') : '',
				address: user?.address,
				codestado: user?.codestado,
				codciudad: user?.codciudad,
				codmunicipio: user?.codmunicipio,
				parish_id: user?.parish_id,
				dniType: user?.dni?.substring(0, 1)
			},
			// selectedPriceId: request?.products[0].selectedPriceId, //ID del producto RCV a comprar
			selectedPriceId: this.state.product_id
		};

		try {
			this.setState({
				isLoading: true
			});

			//Llamo al API que emite la poliza
			const emissionResponse = await GeneralService.acxelCallApi(data);
			console.log('emissionResponse:', emissionResponse);

			this.submit();
		} catch (error) {
			console.log(`Error: ${error}`);

			Alert.error(`Error: ${error}`);
			return;
		}
		finally {
			this.setState({
				isLoading: false
			});
		}
	}

	submit = async () => {
		this.props.dispatch({
        	type: 'SET_IDENTITY_TOKEN',
        	payload: null
        });
        
		await this.setState({
			isLoading: true,
			initial_loading: false
		});

		let purchaseReqDocVehicleDataID = null; // Para almacenar el ID del documento creado

		const data = {
			...this.state.form,
			purchase_req_doc_id: this.state.purchase_req_doc?.id,
			payment_id: this.props.history?.location?.state?.item?.id,
			status: Constants.PURCHASE.STATUS.APPROVED,
		};

		try {
			// 1. Llamada a updateVehicleData
			const res = await PurchasesService.updateVehicleData(data);

			// Guardamos el ID del documento creado
			purchaseReqDocVehicleDataID = res.id;

			if (res?.message) {
				toast.error(res.message);
				return;
			}

			// 2. Buscar registros con vehicle_data
			const purchaseProductResult = await PurchasesService.getPurchasesProductsPendings(data);
			const purchase_product = purchaseProductResult.data
				?.map(item => ({
					...item,
					payment_id: data.payment_id    // Agregamos payment_id desde data
				}))
				?.find(item =>                   // Buscamos el item con vehicle_data
					item.purchase?.purchase_req_docs?.[0]?.vehicle_data
				);

			if (purchase_product) {
				// 3. Procesar descarga RCV
				await this.downloadRCV(purchase_product, purchaseReqDocVehicleDataID);
			} else {
				console.log('No se encontraron registros con vehicle_data');
				await PurchasesService.deleteVehicleData({ id: purchaseReqDocVehicleDataID }); // Eliminar documento
				return toast.error('Ha ocurrido un error al emitir la poliza');
			}

			//this.confirmModalRef.current?.showModal();
		}
		catch (e) {
			console.error('Error en submit:', e);
			// Eliminar documento si existe
			if (purchaseReqDocVehicleDataID) {
				await PurchasesService.deleteVehicleData({ id: purchaseReqDocVehicleDataID });
			}
			toast.error('Ocurrió un error al procesar la solicitud');
		} finally {
			this.setState({
				isLoading: false
			});
		}
	}

	downloadRCV = async (item, purchaseReqDocVehicleDataID) => {
		console.log(item);
		await this.setState({ isLoading: true });

		try {
			// 1. Pagar la poliza en ACSEL
			try {
				const payInAcselData = {
					route: 'pagos/pagar',
					user_id: item.user.id,
					payment_id: item.payment_id,
					purchase_product_id: item.id,
				}
				const payInAcselRes = await GeneralService.acxelCallApi(payInAcselData);
				console.log(payInAcselRes);

				/*
					Si existe un error, pero el error no es el de 
					"POLIZA SIN PAGOS PENDIENTES" ni "ERROR EN EL PROCESO DE PAGO"
				*/
				if (
					payInAcselRes?.cod_resp !== '0' && 
					!(payInAcselRes?.desc_resp?.includes('POLIZA SIN PAGOS PENDIENTES')) &&
					!(payInAcselRes?.desc_resp?.includes('ERROR EN EL PROCESO DE PAGO')) //(FALTA ESTUDIAR CASO)
				){
					const errorMessage = payInAcselRes?.desc_resp
						|| 'Ocurrió un error al pagar la poliza en ACSEL';
	
					// Eliminar documento de vehicle_data antes de salir
					await PurchasesService.deleteVehicleData({
						id: purchaseReqDocVehicleDataID
					});
	
					this.setState({ isLoading: false });
					toast.error(errorMessage);
					return;
				}
			} catch (error) {
				console.error('Error al Pagar la poliza en ACSEL:', error);
				throw error;
			}

			// 2. Cambiar el status de la compra a "Emitida"
			await this.updateStatus({ id: item.id, status: Constants.PURCHASE.STATUS.APPROVED })

			this.confirmModalRef.current?.showModal();

			this.setState({ isLoading: false });

			return;
		} catch (error) {
			console.error(error);
			// Eliminar documento si existe y no se hizo en la validación anterior
			if (purchaseReqDocVehicleDataID) {
				await PurchasesService.deleteVehicleData({
					id: purchaseReqDocVehicleDataID
				});
			}
			toast.error('Ocurrió un error inesperado');
		} finally {
			this.setState({ isLoading: false });
		}
	};

	// Función auxiliar para obtener el reporte a partir de un idepol y validarlo.
	handleReport = async (idepol) => {
		const pdfRequestData = {
			route: 'reportes/polizas',
			idepol,
		};

		const pdfResponse = await GeneralService.acxelCallApi(pdfRequestData);
		console.log(pdfResponse);
		return this.openPdfReport(pdfResponse);
	};

	// Función auxiliar para validar y abrir la URL del reporte PDF.
	openPdfReport = (pdfResponse) => {
		if (pdfResponse?.URL_REPORT) {
			const reportWindow = window.open(pdfResponse.URL_REPORT, '_blank');
			if (!reportWindow || reportWindow.closed || typeof reportWindow.closed === 'undefined') {
				toast.error('El navegador bloqueó la apertura del reporte. Por favor habilite los pop-ups para este sitio.');
				return false;
			}
			return true;
		} else {
			toast.error('No se recibió una URL válida para el reporte');
			return false;
		}
	};

	updateStatus = async (form) => {
		await this.setState({
			isLoading: true
		});

		try {
			await SubscriptionsService.admin.updateStatus(form);

		} catch (error) {
			console.log(error)
		}

		this.setState({ isLoading: false });
	}

	closeConfirmModal = () => {
		this.confirmModalRef.current?.close();
		this.props.history.push('/historial/pagos');
	}

	render() {
		const { form, isLoading, attempts_available, initial_loading } = this.state;

		return (
			<>	
				{isLoading && (
					<div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
						<Spinner />
					</div>
				)}

				<dialog
					ref={this.confirmModalRef}
					className="fixed inset-0 z-50 overflow-y-auto bg-transparent"
					onClose={this.closeConfirmModal}
				>
					<div
						className="w-[20rem] bg-white rounded-xl overflow-hidden p-4 flex flex-col items-center"
						onClick={this.closeConfirmModal}
					>
						<button className="absolute top-3 right-3">
							<img src={CloseIcon} className="w-4 h-4 object-contain" alt="" />
						</button>

						<img src={Vector4} className="w-32 h-32 object-contain" alt="" />
						<p className="text-center font-semibold">
							En pocos minutos recibirás tu póliza en el correo electrónico y la App (En la sección Historial de Productos).
						</p>
						<button
							className={classNames(
								'rounded-lg w-full text-center h-10 font-bold text-lg my-2 disabled:bg-gray6 disabled:text-gray3 bg-yellow text-black'
							)}
						>
							<span>Cerrar</span>
						</button>
					</div>
				</dialog>

				<div className="max-w-[600px] mx-auto">
					{
						this.state.purchase_req_doc?.url ? (
							<>
								<div className="relative">
									<img src={ process.env.REACT_APP_BASE_STORAGE + this.state.purchase_req_doc?.url } className="max-w-[100%] w-[600px] h-[300px] object-cover" />
									{
										attempts_available > 0 && (
											<DocUploadItem
												button={
													<div className="bg-blue rounded-full mt-1 py-1 px-2 font-semibold text-white flex items-center absolute bottom-3 right-3">
														<img className="h-5 w-5 object-contain mr-2" src={ RestartIcon } />
														<span>Reintentar</span>
													</div>
												}
												onUpload={ (file) => {
													this.setState({
														document_photo: file
													},() => {
														this.getData();
													});
												} }
											/>
										)
									}
								</div>
								{
									attempts_available <= 0 && (
										<p className="font-bold mb-3 mt-3 text-blue">Ha alcanzado la cantidad máxima de intentos. Por favor, llene los campos manualmente.</p>
									)
								}
								<p className="font-semibold mb-3 mt-3">Para continuar, por favor verifica que los datos esten correctos o vuelva a tomar la foto</p>
								<div className="flex flex-row items-center">
				                    <div className="w-2/3">
				                      <p className="font-semibold mb-1 mt-2">Marca</p>
									  <Input
										// placeholder="Marca"
										value={form.brand}
										onValueChange={v => this.change(v,'brand',undefined,true)}
									  />
				                    </div>
				                    <div className="w-1/3 pl-4">
				                      <p className="font-semibold mb-1 mt-2">Placa</p>
									  <Input
										// placeholder="Placa"
										value={form.plate}
										onValueChange={v => this.change(v,'plate',undefined,true)}
									  />
				                    </div>
				                </div>
								<div className="flex flex-row items-center">
				                    <div className="w-2/3">
				                      <p className="font-semibold mb-1 mt-2">Modelo</p>
									  <Input
										// placeholder="Modelo"
										value={form.model}
										onValueChange={v => this.change(v,'model',undefined,true)}
									  />
				                    </div>
				                    <div className="w-1/3 pl-4">
				                      <p className="font-semibold mb-1 mt-2">Año</p>
									  <Input
										// placeholder="Año"
										value={form.year}
										onValueChange={v => {
											if ((Globals.validateInteger(v) || v == '') && v.length <= 4) {
												this.change(v,'year',undefined,true);
											}
										}}
									  />
				                    </div>
				                </div>
								<div className="flex flex-row items-center">
									<div className="w-2/3">
										<p className="font-semibold mb-1 mt-2">Serial N.I.V.</p>
										<Input
											// placeholder="Serial N.I.V."
											value={form.serial}
											onValueChange={v => this.change(v,'serial',undefined,true)}
										/>
									</div>
									<div className="w-1/3 pl-4">
										<p className="font-semibold mb-1 mt-2">Cap. Carga KGS</p>
										<Input
											// placeholder="Cap. Carga KGS"
											value={form.weight}
											onValueChange={v => {
												if ((Globals.validateInteger(v) || v == '') && v.length <= 4) {
													this.change(v,'weight',undefined,true);
												}
											}}
										/>
									</div>
								</div>
								<div className="flex flex-row items-center">
									<div className="w-[50%]">
										<p className="font-semibold mb-1 mt-2">Tipo de Vehículo</p>
										<Input
											// placeholder="Tipo de Vehículo"
											value={form.vehicle_type}
											onValueChange={v => this.change(v,'vehicle_type',undefined,true)}
										/>
									</div>
									<div className="w-[50%] pl-4">
										<p className="font-semibold mb-1 mt-2">Color</p>
										<Input
											// placeholder="Color"
											value={form.color}
											onValueChange={v => this.change(v,'color',undefined,true)}
										/>
									</div>
								</div>								
								<button className="w-full bg-yellow rounded-xl mt-4 py-2 px-2 font-semibold text-black" onClick={ this.submit }>
									Continuar
								</button>
							</>
						) : (
							<>
								{
									!initial_loading && (
										<>
											<p className="text-center font-bold text-3xl mb-2">¡Gracias por tu compra!</p>
											<p className="text-center mb-5">Para activar tu RCV completa los siguientes pasos</p>
											<div className="text-center">
												<img src={ NoFileImage } className="w-[300px] rounded-xl object-contain inline-block" />
											</div>
											<p className="font-bold mb-2 mt-5">Para generar tu RCV necesitamos uno de estos documentos</p>
											<div className="mb-5">
												<p>- Título de propiedad</p>
												<p>- Carnet de Circulación</p>
											</div>
											<p className="mb-3">Realizada la verificación envíaremos tu RCV luego de unos minutos</p>
											<p className="mb-3">Pulsa <strong>"Continuar"</strong> para subir el documento</p>
											<DocUploadItem
												button={
													<div className="w-full bg-blue rounded-xl mt-1 py-2 px-2 font-semibold text-white text-center">
												    	Continuar
												    </div>
												}
												onUpload={ (file) => {
													this.setState({
														document_photo: file
													},() => {
														this.getData();
													});
												} }
											/>
										</>
									)
								}
							</>
						)
					}

					<div className="mt-4 flex justify-center">
						<div className="flex items-center">
							<p className="mr-2">Con tecnología</p>
							<img src={ BravealoImage } className="w-[100px] h-[25px] object-contain" />
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default connect(state => {
	return {
		user: state.user
	}
})(CompleteVehicleData);

const DocUploadItem = ({ onUpload, button }) => {
  return (
    <label className="cursor-pointer">
      { button }

      <input
        type="file"
        className="hidden"
        accept="image/jpeg,image/png"
        onChange={e => {
        	onUpload(e.target.files[0]);
        	e.target.value = null;
        }}
      />
    </label>
  );
};

export {
	DocUploadItem
}